import { PropertyValueMap, unsafeCSS } from 'lit'
import { html } from 'lit/static-html.js'

import { DdsElement } from '@/internal/dds-hu-element'

import styles from './timeline.scss?inline'

/**
 * `dap-ds-timeline`
 * @summary A timeline is a graphical representation of a series of events.
 * @element dap-ds-timeline
 * @title - Timeline
 *
 * @slot - The default slot for the timeline items.
 *
 * @csspart base - The main timeline container.
 */
export default class DapDSTimeline extends DdsElement {
  static tagName = 'dap-ds-timeline'

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    super.firstUpdated(_changedProperties)
    this.setAttribute('role', 'list')

    const children = Array.from(this.children)

    children.forEach((child, index) => {
      child.setAttribute('role', 'listitem')
      if (index === 0) {
        child.toggleAttribute('first')
      } else if (index === children.length - 1) {
        child.toggleAttribute('last')
      } else {
        child.removeAttribute('first')
        child.removeAttribute('last')
        child.toggleAttribute('middle')
      }
    })
  }

  render() {
    return html`
      <div part="base" class="timeline">
        <slot></slot>
      </div>
    `
  }
}
